module.exports = __webpack_public_path__ + "img/61.eafd2814.png";